export default {"src":"/_next/static/image/public/images/flags/flag_34.eb02085d12078433224a3f82e861733d.svg","height":16,"width":24};